//
import xlsx from 'xlsx'

//
export default {
    /**
     * @description
     * Concat value with input param selected array
     *
     * @param      {array}  selected  The selected
     * @return     {array}  new value with selected concated
     */
    concatValueWith(selected) {
        return this.value.concat(
            selected.filter(this.filterByKey(this.selectedKey, this.value))
        )
    },

    /**
     * @description
     * cast xlsx file from print data
     */
    exportPrintData() {
        // set the required xlsx params
        const sheet = xlsx.utils.json_to_sheet(this.printData.rows, {
                header: this.printData.columns,
            }),
            book = xlsx.utils.book_new()

        // append xlsx data
        xlsx.utils.book_append_sheet(book, sheet, this.exportTitle)

        // return xlsx file
        xlsx.writeFile(book, this.exportName.concat('.xlsx'))

        //
        this.exportDialog = false
        this.exportLoading = false
    },

    /**
     * @description
     * fetch data
     */
    async fetch() {
        // determine if has a service
        const hasService = !!this.service && !!this.service.fetchDataTable

        // if has service fetch from serve, if not has service set from value
        if (hasService) {
            return this.fetchFromService()
                .then(this.parser)
                .then(this.setDataFromFetch)
        } else {
            return this.setDataFromValue()
        }
    },

    /**
     * @description
     * fetch from default
     */
    fetchFromDefault() {
        return {
            data: [],
        }
    },

    /**
     * @description
     * fetch from request
     */
    fetchFromService() {

        // determine the required params for request to service
        const reqLimit = this.currentLimit,
            reqPage = this.currentPage,
            reqSort = this.currentSort,
            reqParams = this.currentParams

        //
        console.log({
            reqParams,
        })

        // determine if has a service to fetch from service
        return this.service.fetchDataTable(
            reqLimit,
            reqPage,
            reqSort,
            reqParams
        )
    },

    /**
     * { lambda_description }
     *
     * @param      {<type>}           key     The key
     * @param      {<type>}           arr     The arr
     * @return     {(Object|number)}  { description_of_the_return_value }
     */
    filterByKey: (key, arr) => item => arr.every(sel => item[key] !== sel[key]),

    /**
     * { function_description }
     *
     * @return     {<type>}  { description_of_the_return_value }
     */
    filterBySearchStringify: () => {
        // week collection
        const seen = new WeakSet()

        // stringify replacer
        return (key, value) => {
            if (typeof value === 'object' && value !== null) {
                if (seen.has(value)) {
                    return
                }

                seen.add(value)
            }

            return value
        }
    },

    //JSON.stringify(circularReference, getCircularReplacer());

    /**
     * { lambda_description }
     *
     * @param      {<type>}           key     The key
     * @param      {<type>}           arr     The arr
     * @return     {(Object|number)}  { description_of_the_return_value }
     */
    filterBySearch(item) {
        return JSON.stringify(item, this.filterBySearchStringify())
            .toLowerCase()
            .includes(this.toolbar.search.toLowerCase())
    },

    /**
     * @description
     * determine if header has value param
     */
    hasValue(header) {
        return !!header.value
    },

    /**
     * @description
     * return column name param
     */
    mapColumnToPrint(column) {
        return column.text
    },

    /**
     * Map filter values
     *
     * @param      {<type>}  [opts={}]    The options
     * @param      {<type>}  [filter={}]  The filter
     * @return     {<type>}  { description_of_the_return_value }
     */
    mapFilter(opts = {}, filter= {}) {
        return Object
            .keys(opts)
            .reduce((r, c) => ({ 
                ...r, 
                [c]: Array.isArray(opts[c]) ? 
                    opts[c].join() 
                    : 
                    opts[c] 
            }), filter)
    },

    /**
     * @description
     * cast column from header
     */
    mapRowToPrint(row) {
        return this.headers.reduce(this.mapRowValueToPrint(row), {})
    },

    /**
     * @description
     * cast column from header
     */
    mapRowValueToPrint: row => (total, header) => {

        //
        const rowValue = typeof header.value === 'function' ? header.value(row) : row[header.value]

        //
        // console.log({ row, header, rowValue })

        //
        switch (typeof rowValue) {
            case 'boolean':
                return  { ...total, [header.text]: rowValue ? 'Si' : 'No' }
            case 'number':
            case 'string':
                return { ...total, [header.text]: rowValue }
            case 'object':
                return { ...total, [header.text]: Array.isArray(rowValue) ? rowValue.join('\n') : '' }
            /*case 'function':
                return { ...total, [header.text]: header.value(row) }*/
            default:
                return total
        }
    },

    /**
     * @description
     * fetch data and toggle the busy state
     */
    refresh() {

        console.log('refresh', this.busy)

        //        
        if (!this.busy) {

            //
            this.busy = this.occupy === 0 ? true : this.busy
            this.occupy += 1

            //
            return this.fetch()          
        }
    },

    /**
     * @description
     * set a attach filter
     *
     * @param {String} name - filter name
     * @param {Any} value - filter value
     */
    setAttachFilter(name, value) {
        this.attachFilter = {
            [name]: value,
        }
    },

    /**
     * @description
     * set data from default
     */
    setDataFromDefault() {
        this.setDataFromFetch({
            from: 1,
            current_page: 1,
            data: [],
            last_page: 1,
            to: 1,
            total: 0,
        })
    },

    /**
     * @description
     * set data from request
     *
     * @param {Object} payload - the response request data
     */
    setDataFromFetch({ from, current_page, data, last_page, to, total }) {

        // set pagination
        this.pagination.current =
            last_page < current_page ? last_page : current_page
        this.pagination.from = from
        this.pagination.length = last_page
        this.pagination.to = to
        this.pagination.total = total

        //
        if (this.remindKey) {

            // storage keys
            const localStoragePaginationCurrent = this.remindKey.concat('-pagination-current')
            const localStoragePaginationLimit = this.remindKey.concat('-pagination-limit')
            const filterKey = this.remindKey.concat('-filter')
            const searchKey = this.remindKey.concat('-search')

            // set storage pagination
            localStorage.setItem(localStoragePaginationCurrent, this.pagination.current)
            localStorage.setItem(localStoragePaginationLimit, this.pagination.limit)
            localStorage.setItem(filterKey, JSON.stringify(this.filter || {}))
            localStorage.setItem(searchKey, this.toolbar.search || '') 
        }

        //
        //console.log(this.persistentData.length > 0)
        if (this.persistentData.length > 0) {
            //console.log(this.selected)
            this.selected.forEach(selected => {
                let item = data.find(({ id }) => selected.id === id)
                if ( item ) {
                    this.persistentData.forEach(attr => {
                        item[attr] = selected[attr]
                    })
                }
            })
        }

        // set sync pagination
        this.paginationSync.page = this.pagination.current
        this.paginationSync.rowsPerPage = this.pagination.limit
        this.paginationSync.totalItems = this.pagination.total

        // set data
        this.data = this.mapper ? data.map(this.mapper) : data

        // set selected
        if (!this.persistentSelection)
            this.selected = this.selected.filter(select =>
                data.some(({ id }) => select.id === id)
            )

        //
        this.exportLength = this.pagination.total

        // set busy state
        this.busy = false

        this.occupy -= 1

        // return the data table
        return this.data
    },

    /**
     * Set data print from request.
     *
     * @param {object} payload - the response request data.
     */
    setPrintDataFromFetch({ data }) {

        // debug data received
        // console.log({ data })

        // parse if the data is a object
        if (typeof data === 'object') {
            data = Object.values(data)
        }

        // required data
        const length = data.length + this.printData.rows.length
        const required = this.exportLength - this.printData.rows.length
        const noLast = length < this.exportLength
        const sliceLength = noLast ? data.length : required

        // set the new print rows
        this.printData.rows = this.printData.rows.concat(data.slice(0, sliceLength).map(this.mapper).map(this.mapRowToPrint))
    },

    /**
     * @description
     * set data from value
     */
    setDataFromValue() {
        this.data = this.noSearch
            ? this.value
            : this.value.filter(this.filterBySearch)
        this.exportLength = this.data.length
        this.busy = false
    },

    /**
     * @description
     * emit detail with payload
     *
     * @param {Object} item - the current item to payload
     */
    submitDetail(item) {
        this.$emit('detail', {
            item,
        })
    },

    /**
     * @description
     * show excel dialog
     */
    submitExcel() {
        this.exportDialog = true
    },

    /**
     * @description
     * fetch & cast print data
     */
    async submitExport() {
        
        //
        this.exportLoading = true

        //
        const total = this.exportLength
        const limit = Math.min(1250, total)
        const pages = Math.ceil(total / limit)
        const fetch = !!this.service && !!this.service.fetchDataTable
        const sorts = this.currentSort
        const param = this.currentParams

        //
        this.exportValue = 0

        //
        this.printData.columns = this.headers.map(this.mapColumnToPrint)
        this.printData.rows = []

        //
        for (let page = 1; page <= pages; page++) {

            //
            this.exportValue = (page / pages) * 100

            //
            if (fetch) {
                await this.service
                    .fetchDataTable(limit, page, sorts, param)
                    .then(this.parser)
                    .then(this.setPrintDataFromFetch)
            } else {
                this.setPrintDataFromFetch({ data: this.value })
            }
        }

        //
        this.exportPrintData()
    },

    /**
     * @description
     * set current filter and refresh
     */
    submitFilter(event, filter = {}) {
        //console.log({ event }, 'filter')
        //
        Object.keys(event).forEach(key => {
            //
            console.log({event})
            //
            if (Array.isArray(event[key])) {
                filter[key] = event[key].join(',')
            }
            //
            switch (typeof event[key]) {
                case 'array':
                    filter[key] = event[key].join()
                    break
                case 'undefined':
                    break
                default:
                    filter[key] = event[key] !== '' ? event[key] : undefined
                    break
            }
        })

        //
        this.filter = filter

        //
        console.log({ filter })

        //
        this.refresh()
    },

    /**
     * @description
     * Concat current selected with picker selected
     *
     * @param      {object}  event  payload method
     */
    submitPicker(event) {
        //
        //const tableSelected = event.selected.filter(this.filterByKey(this.selectedKey, this.value))

        //
        this.$emit('input', this.concatValueWith(event.selected))
        /*
        this.$emit(
            'input',
            this.value
                .filter(val => event.selected.every(sel => sel.id !== val.id))
                .concat(event.selected)
        )*/
    },

    /**
     * @description
     * emit remove with payload
     *
     * @param {Object} item - the current item to payload
     */
    submitRemove(item) {
        this.$emit('remove', {
            item,
        })
    },

    /**
     * @description
     * return the current value filtered without selected items
     */
    submitRemoveSelected() {
        this.$emit('removed', this.selected)
        this.$emit(
            'input',
            this.value.filter(val =>
                this.selected.every(sel => sel.id !== val.id)
            )
        )
        this.selected = []
    },

    /**
     * @description
     * return value with new added item
     */
    submitAdded(event) {
        this.$emit('input', this.value.concat([event]))
    },

    /**
     * @description
     * toggle all selected items
     */
    toggleAll() {
        this.selected = this.selected.length < this.data.length ? this.data : []
    },

    /**
     * @description
     * toggle busy state
     */
    toggleBusy() {
        this.busy = !this.busy 
    },

    /**
     * @description
     * trigger input component
     */
    trigger(event) {
        // required flags
        const hasInput = !!event.header.input
        const hasTrigger = hasInput && !!event.header.input.trigger
        const canTrigger =
            hasTrigger && typeof event.header.input.trigger === 'function'
        // debug trigger
        //console.log({
        //    hasInput,
        //    hasTrigger,
        //    canTrigger,
        //})
        // exec trigger
        if (canTrigger) {
            event.header.input.trigger(this, event.props)
        }
    },

    /**
     * @description
     * trigger input component
     */
    change(event) { console.log('table:change')

        // required flags
        const hasInput      = !!event.header.input
        const hasTrigger    = hasInput && !!event.header.input.change
        const canTrigger    = hasTrigger && typeof event.header.input.change === 'function'

        //
        if (canTrigger) {
            event.header.input.change(this, event.props)
        }
    },
}
